<template>
  <Modal size="lg">
    <div class="modal-header">{{ "refund_order" | translate }}</div>
    <div class="modal-body">
      <div class="alert alert-warning" v-if="validationError">
        {{ validationError }}
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "vendor" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="refundOrderItem.vendor"
            :placeholder="'vendor' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "refund_order_number" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="refundOrderItem.refundOrderNumber"
            :placeholder="'refund_order_number' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "order_number" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="refundOrderItem.orderNumber"
            :placeholder="'order_number' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "quantity" | translate }}</div>
        <div class="col-9">
          <input
            type="number"
            class="form-control"
            v-model.number="refundOrderItem.quantity"
            :placeholder="'quantity' | translate"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-3">{{ "amount" | translate }}</div>
        <div class="col-6">

          <div class="input-group">
            <input
              type="number"
              class="form-control"
              v-model.number="refundOrderItem.amount"
              :placeholder="'amount' | translate"
            />
            <div class="input-group-append">
              <button class="btn btn-outline-success" type="button"
                      @click="calculateTotal" 
              >
                <i class="fa fa-fw fa-calculator"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-3">
          <currency-picker
            class="form-control"
            v-model="refundOrderItem.currency"
          ></currency-picker>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "comment" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="refundOrderItem.comment"
            :placeholder="'comment' | translate"
          />
        </div>
      </div>

      <part-transaction-list
        :transactions="refundOrderItem.refunds"
        :currency="refundOrderItem.currency"
        :entity="'refund' | translate"
        :total="refundOrderItem.amount"
      ></part-transaction-list>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" @click="cancel">
        {{ "cancel" | translate }}
      </button>
      <button class="btn btn-primary" @click="save">
        {{ "save" | translate }}
      </button>
    </div>
  </Modal>
</template>

<script>
import _ from "lodash";
import PartTransactionList from "./PartTransactionList";
import almostEqual from "@/lib/almostEqual";

export default {
  props: ["editingItem"],
  data() {
    return {
      validationError: null,
      refundOrderItem: {
        currency: null,
        vendor: null,
        refundOrderNumber: null,
        orderNumber: null,
        quantity: null,
        amount: null,
        refunds: [
          {
            account: null,
            amount: null,
            currency: null
          }
        ],
        comment: null,
        timestamp: new Date().getTime()
      }
    };
  },
  created() {
    if (this.editingItem) {
      this.refundOrderItem = _.cloneDeep(this.editingItem);
    }
  },
  methods: {
    cancel() {
      this.$emit("dismiss");
    },
    save() {
      let item = this.refundOrderItem;
      this.assert(item.currency, "currency is required");
      this.assert(item.vendor, "vendor is required");
      this.assert(item.quantity >= 0, "quantity is required");
      this.assert(item.amount, "amount is required");
      this.assert(item.refunds && item.refunds.length, "refund is required");
      this.assert(
        almostEqual(
          item.refunds.reduce((sum, p) => (p.amount ? p.amount + sum : sum), 0),
          item.amount
        ),
        "refund sum shall equal total amount"
      );

      this.$emit("close", this.refundOrderItem);
    },

    assert(value, message) {
      if (!value) {
        this.validationError = message;
        throw new Error("validation failed: " + message);
      }
      this.validationError = null;
    },
    calculateTotal() {
      if (!this.refundOrderItem.refunds) {
        this.refundOrderItem.amount = 0 
        return
      }
      
      let sum = this.refundOrderItem.refunds.reduce((preSum, item) => preSum + item.amount, 0)
      this.refundOrderItem.amount = sum
    }
  },
  components: { PartTransactionList }
};
</script>
